import { ReactElement } from 'react';
import _ from 'lodash';
import Image from 'next/image';

import { icon_arrow_right } from '@gn-audio/icons';

import { PopularSearchesContent } from '../../../types';
import { nameListToArray } from '../../../utils';
import useFallbackTranslation from '../../../utils/hooks/useFallbackTranslation';
import { JabraIcon } from '../../JabraIcon/JabraIcon';
import { SearchTitleHeader } from './SearchTitleHeader';

type PopularProductsProps = {
  popularSearchesFields?: PopularSearchesContent;
  learnMoreText: string;
  popularSearchText: string;
};

function validatePopularSearchesFields(fieldsArray: string[]) {
  const testArray = ['image', 'label', 'path'];
  return _.isEqual(testArray, fieldsArray.sort());
}

export const PopularProducts = ({
  popularSearchesFields,
  learnMoreText,
  popularSearchText,
}: PopularProductsProps): ReactElement => {
  const { t } = useFallbackTranslation();
  const popularSearches = nameListToArray(popularSearchesFields || {});
  const { getURLWithLocalePrefix } = useFallbackTranslation();

  return (
    <>
      {popularSearches.length > 0 ? (
        <>
          <SearchTitleHeader title={popularSearchText} />
          <div
            className="mb-10 grid w-full grid-cols-1 gap-4 xs:grid-cols-2"
            aria-label={t('topmenu.PopularProducts')}
            role="list"
          >
            {popularSearches.map((popularSearchesField) => (
              <>
                {validatePopularSearchesFields(Object.keys(popularSearchesField)) ? (
                  <div
                    key={`popular-${popularSearchesField.image}`}
                    className="p-0.75 flex w-96 items-center justify-start rounded-lg bg-beige-50 hover:bg-beige-50 hover:shadow-shadow10 xs:w-72"
                    tabIndex={0}
                    role="listitem"
                  >
                    <Image
                      className="w-32 rounded-lg xs:w-24"
                      src={popularSearchesField.image}
                      alt={popularSearchesField.label}
                      width="300"
                      height="300"
                    />
                    <div className="flex w-48 flex-col justify-center gap-2">
                      <p className="overflow-hidden overflow-ellipsis text-lg font-bold">
                        {popularSearchesField.label}
                      </p>
                      <a
                        href={getURLWithLocalePrefix(popularSearchesField.path)}
                        role="link"
                        className="w-24 cursor-pointer text-xs font-bold"
                      >
                        <span className="flex items-center gap-1 font-normal text-[0.75]">
                          {learnMoreText} <JabraIcon Icon={icon_arrow_right} className="h-3 pl-1" />
                        </span>
                      </a>
                    </div>
                  </div>
                ) : null}
              </>
            ))}
          </div>
        </>
      ) : null}
    </>
  );
};
